/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:2566fbcf-e68d-4f26-ba6e-802201bb16c3",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Xnzi4zzTz",
    "aws_user_pools_web_client_id": "7r5oi5ucn11bf5cnmuattso318",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "awsstore17ec5dbad41d466fae03db53f1ec82bd223834-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://zdxeliberzhm5lk7z4q7kgqrmq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-xduthv2ipze55bjdckqvj2stqi",
    "aws_content_delivery_bucket": "awsstore-20220802224614-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://awsstore-20220802224614-hostingbucket-prod.s3-website-us-east-1.amazonaws.com"
};


export default awsmobile;
